import React, {useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane
} from "reactstrap";
import classnames from "classnames";
import LineChart from "../../../components/Chart/LineChart";
import ReportTable from "../../report/components/reports/ReportTable";
import BarChartReport from "../../report/components/reports/barChartReport";
import {ReportBarChartTransformer} from "../../services/chart.transformer";
import MapReport from "../../report/components/reports/MapRepot";
import ReportPieChart from "../../report/components/reports/ReportPieChart";

const Reports = (props) => {
    const {data} = props
    const [activeTab, setActiveTab] = useState('1');
    const tabsIds = [
        {id: '1', name: "روند"},
        {id: '2', name: "جدول"},
        {id: '3', name: "نمودار میله ای"},
        {id: '4', name: "نقشه"},
        {id: '5', name: "نمودار دایره ای"},
    ]


    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    return (

        <Col xs={6}>
            <Card>
                <CardBody>
                    <Nav tabs>
                        {data && tabsIds && tabsIds.map(tab => {
                            if (tab.id !== '5' || (tab.id === '5' && data.pie.length > 0)) {
                                return (
                                    <NavItem className={`reportTab`} key={tab.id}>
                                        <NavLink
                                            key={tab.id}
                                            className={classnames({active: activeTab === tab.id})}
                                            onClick={() => {
                                                toggle(tab.id)
                                            }}>
                                            {tab.name}
                                        </NavLink>
                                    </NavItem>
                                )
                            }
                        })
                        }

                    </Nav>
                    <button  className={"deleteBtn"} onClick={()=>props.onClick(props.boxId)}>
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <Row className="result-title text-right">
                        <Col>
                            <p>{data != null ? data?.title : null}</p>
                        </Col>
                    </Row>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <Row className={'p-3'}>
                                <Col sm="12">
                                    <Card>
                                        <CardHeader className={"text-right "}>
                                            <h5 className="card-category">نمودارخطی</h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="chart-area" style={{minHeight: 300}}>
                                                {data && <LineChart
                                                    datasets={data.trend}
                                                />}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="2">
                            <Row className={'p-3 h-70vh'}>
                                {data &&
                                <ReportTable
                                    data={data?.values}
                                />
                                }
                            </Row>
                        </TabPane>
                        <TabPane tabId="3">
                            <Row className={'p-3'}>
                                {data &&
                                <BarChartReport
                                    transformer={ReportBarChartTransformer}
                                    data={data?.values}
                                />
                                }

                            </Row>
                        </TabPane>
                        <TabPane tabId="4">
                            <Row className={'p-3 width'}>
                                {data &&
                                <MapReport
                                    chartdata={data?.values}
                                    quarters={data?.quarters}
                                    years={data?.years}/>
                                }
                            </Row>
                        </TabPane>
                        {data && data?.pie.length !== 0 &&
                        <TabPane tabId="5">
                            <Row className={'p-3'}>
                                <ReportPieChart
                                    data={data?.pie}
                                    years={data?.years}
                                />
                            </Row>
                        </TabPane>
                        }
                    </TabContent>
                </CardBody>
            </Card>
        </Col>

    )
}

export default Reports;